import styled from "styled-components";

export const Nav = styled.nav`
	border: 1px solid #B3B3B3;
	border-radius: 5px;
	overflow: hidden;
`
